import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {basicColor} from "@/styles/template";
import Icon from '@/components/atoms/UI/Icon/Icon';

interface Props {
    src: string;
    alt?: string;
    className?: string;
    size?: string;
}

const ImageWrapper = styled.div<{ size?: string}>`
    height: 70px;
    width: 70px;
    min-width: 70px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.theme.color.LightItem};
    ${({ size }) => size && css`
        height: ${size}rem;
        width: ${size}rem;
        min-width: ${size}rem;
    `}
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const CircleImage: React.FC<Props> = ({ src, alt = '', size }) => {
    const [isImageError, setIsImageError] = useState(false);

    const isValidSrc = src && src.trim() !== '';

    return (
        <ImageWrapper size={size} >
            {isValidSrc && !isImageError ? (
                <Image
                    src={src}
                    alt={alt}
                    onError={() => setIsImageError(true)}
                />
            ) : (
                <Icon name='Img' />
            )}
        </ImageWrapper>
    );
};

export default CircleImage;